import { defaultText } from '@phaser/helpers/Text';
import { DEPTH } from '@phaser/data/depth';
import { Game } from '@phaser/scenes/Game';

export class DamageNumber {
  private scene: Game = Game.current;

  constructor(
    private x: number,
    private y: number,
    private value: number,
    private _alpha: number = 1,
  ) {
    const { scale, color, isCrit } = this._getStyle();

    const str = this.value < 0
      ? `+${Math.abs(this.value)}`
      : this.value.toString();

    const text = this.scene.add.text(this.x, this.y, str, {
      ...defaultText,
      fontSize: `${Math.floor(16 + scale * 8)}px`,
      color,
      strokeThickness: isCrit ? 3 : 2,
    })
      .setAlpha(this._alpha)
      .setOrigin(0.5)
      .setScale(isCrit ? 1.4 : 1.1)
      .setDepth(DEPTH.DAMAGE_NUMBER);

    if (isCrit) {
      this._showCritBurst(this.x, this.y);
    }

    this.scene.add.tween({
      targets: text,
      y: this.y - (isCrit ? 72 : 52),
      scale: isCrit ? 1.0 : 0.85,
      ease: isCrit ? 'Back.out' : 'Power2',
      duration: isCrit ? 380 : 280,
      onComplete: () => {
        this.scene.add.tween({
          targets: text,
          alpha: 0,
          duration: isCrit ? 600 : 450,
          onComplete: () => text.destroy(),
        });
      },
    });
  }

  private _getStyle() {
    if (this.value < 0) {
      return { color: '#44FF88', scale: 1.8, isCrit: false };
    }
    if (this.value === 0) {
      return { color: '#888888', scale: 1.2, isCrit: false };
    }
    if (this.value >= 150) {
      return { color: '#FF2200', scale: 2.4, isCrit: true };
    }
    if (this.value >= 80) {
      return { color: '#FF6600', scale: 2.1, isCrit: true };
    }
    if (this.value >= 30) {
      return { color: '#FFD700', scale: 1.8, isCrit: false };
    }
    return { color: '#ffffff', scale: 1.4, isCrit: false };
  }

  private _showCritBurst(x: number, y: number) {
    // Star-burst effect for crits
    const count = 5;
    for (let i = 0; i < count; i++) {
      const angle = (i / count) * Math.PI * 2;
      const len = 10 + Math.random() * 14;

      const line = this.scene.add.rectangle(
        x + Math.cos(angle) * 4,
        y + Math.sin(angle) * 4,
        len, 2,
        i % 2 === 0 ? 0xFFD700 : 0xFF6600,
      )
        .setDepth(DEPTH.DAMAGE_NUMBER - 1)
        .setRotation(angle)
        .setOrigin(0, 0.5);

      this.scene.add.tween({
        targets: line,
        x: x + Math.cos(angle) * (len + 12),
        y: y + Math.sin(angle) * (len + 12),
        alpha: 0,
        scaleX: 0.1,
        duration: 280,
        ease: 'Power2',
        onComplete: () => line.destroy(),
      });
    }
  }
}
